// Code generated by protoc-gen-ts_proto_ipc_plugin. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto_internal_plugin  v0.1.20
//   protoc               v6.30.2
// source: services/analytics/analytics.proto

/* eslint-disable */
import { Injectable } from "@angular/core";
import { GrpcWebErrrHandlingImpl } from "src/app/shared/services/grpc-client";
import { EmptyResponse } from "../../common/messages/messages";
import { CounterRequest } from "./analytics";

import { AnalyticsServiceClientImpl } from "./analytics";

@Injectable({ providedIn: "root" })
export class AnalyticsServiceSpa {
  constructor(private _rpc: GrpcWebErrrHandlingImpl) {}
  async updateCounter(request: CounterRequest): Promise<EmptyResponse> {
    const client = new AnalyticsServiceClientImpl(this._rpc);
    return await client.updateCounter(request);
  }
}
